import React from 'react';
import { HeaderLabelWithAccessories } from '@amzn/unified-data-table-components/core';
import { useTranslateMapItem } from '@urc-ui/hooks/translate-map';
import { COLUMN_TOOLTIP_TRANSLATION_MAP, COLUMN_TRANSLATION_MAP } from '@urc-ui/pages/landing/subscriptions-table/column-configurations';

type HeaderWithTooltipProps = {
  colId: string;
};

export function HeaderWithTooltip(props: HeaderWithTooltipProps) {
  const headerName = useTranslateMapItem(COLUMN_TRANSLATION_MAP, props.colId);
  const helpText = useTranslateMapItem(COLUMN_TOOLTIP_TRANSLATION_MAP, props.colId);

  return <HeaderLabelWithAccessories headerName={headerName} helpText={helpText} />;
}
